import React from 'react';
import ReactDOM from 'react-dom';
import ImageSwiper from './ImageSwiper';

const ModalCarousal = (props) => {
  return ReactDOM.createPortal(
    <ModalUnit
      open={props.open}
      images={props.images}
      closeModal={props.closeModal}
    />,
    document.getElementById('portal')
  );
};

const ModalUnit = (props) => {
  return (
    <>
      {props.open ? (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={props.closeModal}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <ImageSwiper images={props.images} isModal={true} />
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default ModalCarousal;
